import http from '@/communication/AuthConnection'

export default () => {
  return http.get('/v1/occupation')
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/occupation/GetOccupationList.js